function loadCopys(url) {
  const baseJson = 'base/services/text.js';
  const baseUrl = '/salud/Style%20Library/webparts/';
  const fullJson = baseUrl + baseJson;
  const fullUrl = baseUrl + url;
  const base = fetch(fullJson)
  .then(res =>  res.json());
  const loaded = fetch(fullUrl)
  .then(res =>  res.json());
  Promise.all([base, loaded]).then(values => {
    const res = { ...values[0], ...values[1]};
   // console.log(res)
    i18next.init({
      lng: 'es',
      fallbackLng: "es",
      resources: {
        es: {
          translation: res,
        }
      },
    });
  }).catch(err => console.log('error', err));
}

export default loadCopys;